import { Box2dModel, TLShape, Vec2d } from '@tldraw/tldraw'
import { MaskShape } from './Types'

function getContainer(shape: MaskShape) {
  const mask = shape.props.mask
  const topLeft = mask?.topLeft
  if (!topLeft) {
    return {
      offsetX: 0,
      offsetY: 0,
      w: shape.props.w,
      h: shape.props.h,
    }
  }

  const w = (1 / (mask.bottomRight.x - mask.topLeft.x)) * shape.props.w
  const h = (1 / (mask.bottomRight.y - mask.topLeft.y)) * shape.props.h

  const offsetX = -topLeft.x * w
  const offsetY = -topLeft.y * h

  return {
    offsetX,
    offsetY,
    w,
    h,
  }
}

/**
 * The bounding box of the content of the shape. This is the area covered by
 * the content of the shape as if it were not masked.
 */
export function getContentBounds(shape: MaskShape): Box2dModel {
  const { w, h, offsetX, offsetY } = getContainer(shape)

  const mask = shape.props.mask
  if (!mask) {
    return {
      x: 0,
      y: 0,
      w,
      h,
    }
  }

  const vec = Vec2d.From(shape).addXY(offsetX, offsetY).rotWith({ x: shape.x, y: shape.y }, shape.rotation)

  return {
    x: vec.x,
    y: vec.y,
    w,
    h,
  }
}

export function getContainerStyle(shape: MaskShape) {
  const { w, h, offsetX, offsetY } = getContainer(shape)
  return {
    width: w,
    height: h,
    transform: `translate(${offsetX}px, ${offsetY}px)`,
  }
}

export function isSingleImage(shapes: TLShape[]): boolean {
  return shapes.length === 1 && shapes[0].type === 'image'
}
